export const ORGANIZATION = {
    supportPhone: "+1.833.223.3330",
    supportEmail: "help@greenbelt.co",
    supportHours: "8am to 8pm CST, 7 days a week"
}